/**
 * The scroll area's corner height.
 * @type {number}
 */
export const scrollAreaCornerHeight = '--scroll-area-corner-height';
/**
 * The scroll area's corner width.
 * @type {number}
 */
export const scrollAreaCornerWidth = '--scroll-area-corner-width';